import { useEffect, useState } from 'react'
import { isFirefox } from 'lib/ie-version'

// 是否为 Firfox
function useFireFox() {
  const [value, setValue] = useState(false)

  useEffect(() => {
    const value = isFirefox()
    setValue(value)
  }, [])

  return value
}

export default useFireFox
